import { Component, Input, Output, EventEmitter } from "@angular/core";
import {
  BestellingBewerkingDto
} from "../../shared/api-models/models";
import { BaseComponent } from "../../shared/base.component";

@Component({
  selector: "bewerkingen-pill",
  templateUrl: "./bewerkingen-pill.component.html",
  styleUrls: ["./bewerkingen-pill.component.css"],
})
export class BewerkingenPillComponent extends BaseComponent {
  @Input("bewerking") public bewerking: BestellingBewerkingDto;
  @Output() bewerkingRemoved: EventEmitter<any> = new EventEmitter();

  constructor() {
    super();
  }

  public removePill() {
    this.bewerkingRemoved.emit();
  }
}
